import { GetApiClient } from "@/utils/api-client";
import { DataSchema } from "common";

type GetUserResponse = DataSchema.AuthUser;

export const getUserApi = (apiClient: GetApiClient) => {
  return apiClient.get<GetUserResponse>("/api/authuser");
};
